<!--
   Created by qing on 2021/11/28 7:03 下午
   Des: 气泡地图视图
-->

<template>
  <div class="bubble-map-view-page">

    <div class="map-header" ref="mapHeader">
      <div class="location-address-container">
        <div class="location-address-wrapper">
          定位地址：
          <span class="location-address">
            {{locationAddr}}
          </span>
        </div>
        <div class="tips">
          (点击地图任意位置获取手动定位)
        </div>
      </div>
      <div class="select-container">
        <div>
          附近
        </div>
        <div class="select" @click="radiusShow = true">
          {{radius === 100000000 ? '不限距离' : `${radius}米`}}
        </div>
        <div>
          的数据
        </div>
      </div>
    </div>

    <div class="map__container-wrapper">
      <el-amap vid="amap" ref="amap" class="amap-demo">
      </el-amap>
    </div>

    <van-popup
      class="list-card-popup"
      v-model="show"
      position="bottom"
      :overlay="overlay"
      get-container="body"
      close-on-popstate
      :close-on-click-overlay="false"
      @click-overlay="onClickOverlay"
      :style="{ height: popupHeight }">
      <div
        class="popup-title"
        @click="onClickTitle">
        数据列表
        <span style="color: #05A971; margin-left: 10px">(共{{showDataList.length}}条数据)</span>
      </div>
      <div class="list-card-container">
        <div
          v-if="isAdmin || viewSet.openSearch === 'YES'"
          class="select-group"
          @click="onClickFilter">
          <span v-if="filter && filter.conditionList  && filter.conditionList.length">
            已选择{{filter.conditionList.length}}条筛选条件
          </span>
          <span v-else>
            未选择筛选条件
          </span>
        </div>
        <template v-if="showDataList.length">
          <div class="list-card" v-for="item in showDataList" :key="item.instanceId">
            <div class="list-card-wrapper" @click="onClickCard(item)">
              <div class="card-info" :style="{width: viewSet.cardConfigInfo.showImage && item.image.showData ? 'calc(100% - 100px)' : '100%'}">
                <div class="title">
                  <div
                    class="color"
                    v-if="viewSet.cardConfigInfo.showColor"
                    :style="{backgroundColor : item.color ? item.color.showData : ''}"
                  ></div>
                  <h3
                    v-if="viewSet.cardConfigInfo.showTitle">
                    {{item.title.showData}}
                  </h3>
                </div>
                <p v-if="viewSet.cardConfigInfo.showTime">
                  {{actionFormatDate(item.time.showData, item.time.formatStr) || ''}}
                </p>
                <div class="card-info-row">

                  <div
                    class="row-item"
                    v-for="showData in item.content"
                    :key="showData.fieldId">
                    <h5>
                      {{showData.fieldTitle}}：
                    </h5>
                    <div class="item-content">
                      <FieldShowData
                        :show-data="showData"
                        :memberShowType="viewSet.cardConfigInfo.memberShowType">
                      </FieldShowData>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img-container" v-if="viewSet.cardConfigInfo.showImage && item.image.showData">
                <img :src="item.image.showData" alt="">
              </div>
            </div>
          </div>
        </template>
        <div v-else class="empty-data-container">
          <van-icon name="todo-list-o" />
          <div>暂无数据</div>
        </div>
      </div>
    </van-popup>

    <form-data-filter
      v-if="formSet && formSet.isInit"
      ref="formDataFilter"
      :form-id="formId"
      @selectFilterComplete="actionSelectFilterComplete">
    </form-data-filter>

    <van-action-sheet
      v-model="radiusShow"
      title="选择范围"
      get-container="body"
      @select="onSelectRadius"
      :close-on-click-action="true"
      :actions="radiusOpts">
    </van-action-sheet>
  </div>
</template>

<script>
  import FormSet from "../RyForm"
  import ViewSet from "../RyView"
  import {
    FORM_TYPE__FILL,
    FORM_ITEM__SINGLE_LINE,
    DATE_TYPE__DAY,
    DATE_TYPE__MONTH,
    DATE_TYPE__MINUTE,
    DATE_TYPE__SECTION,
    DATE_TYPE__YEAR, FORM_ITEM__IMAGE, FORM_ITEM__DATE
  } from "../RyForm/types"
  import {SUCCESS} from "../store/types"
  import {clone, formatDate, arrCompare, getFilterResults} from "../../assets/js/Untis"
  import {
    FORM_VIEW_TYPE_WRITE_FORM,
    FORM_VIEW_TYPE_DATA_HANDLE,
    FORM_VIEW_TYPE_DATA_VIEW,
    FORM_VIEW_TYPE_BOARD_VIEW, FORM_VIEW_TYPE_MAP_PATH_VIEW
  } from "../../assets/types/index"
  import {uuid} from "../RyForm/utils";
  import FieldShowData from "./FieldShowData"
  import FormDataFilter from "./FormDataFilter";

  export default {
    props: {
      formId: {
        type: String,
        default: ''
      },
      viewId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        FORM_VIEW_TYPE_DATA_VIEW,
        FORM_VIEW_TYPE_BOARD_VIEW,
        FORM_VIEW_TYPE_MAP_PATH_VIEW,
        map: null,
        show: true,
        popupHeight: '40px',
        overlay: false,
        selectVisible: false,
        loading: true,
        viewSet: ViewSet.init({
          userId: this.$store.getters.userId,
          formId: this.formId,
          viewId: this.viewId,
          companyId: this.$store.getters.currentCompanyId,
          appId: this.$store.getters.currentAppId
        }),
        formSet: FormSet.init({
          userId: this.$store.getters.userId,
          companyId: this.$store.getters.currentCompanyId,
          formId: this.formId,
          appId: this.$store.getters.currentAppId
        }),
        relateViewSet: null,
        filter: {},

        plugin: [{
          pName: 'Geolocation',
          events: {
            click: (o) => {
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {

                }
              });
            }
          },
          buttonPosition: 'LT'
        }],
        center: [108.947325, 34.317759],

        radio: 'data',
        pointList: [],
        showDataList: [],
        markerArray: [],

        locationAddr: '',
        locationMarker: null,
        locationInfo: {
          latitude: 0,
          longitude: 0
        },
        radius: 100000000,
        radiusOpts: [
          {
            name: '1000米',
            value: 1000
          },
          {
            name: '2000米',
            value: 2000
          },
          {
            name: '3000米',
            value: 3000
          },
          {
            name: '4000米',
            value: 4000
          },
          {
            name: '5000米',
            value: 5000
          },
          {
            name: '不限',
            value: 100000000
          },
        ],
        radiusShow: false
      };
    },
    components: {
      FieldShowData,
      FormDataFilter
    },
    created() {
      setTimeout(() => {
        this.getLocation()
      },2000)

    },

    computed: {
      isAdmin() {
        const adminInfo = this.$store.getters.adminInfo
        return adminInfo && (adminInfo.creator || adminInfo.topAdmin)
      },
      fieldList() {
        let fields = this.formSet.filterField({
          invertType: [
            FormSet.TYPES.FORM_ITEM__SECTION,
            FormSet.TYPES.FORM_ITEM__RTF,
            FormSet.TYPES.FORM_ITEM__TABLE,
            FormSet.TYPES.FORM_ITEM__SUMMARY,
            FormSet.TYPES.FORM_ITEM__DESCRIPTION,
            FormSet.TYPES.FORM_ITEM__BUTTON
          ]
        }).filter(field => field.parent.type !== FormSet.TYPES.FORM_ITEM__TABLE)
        return fields
      },
    },
    methods: {

      fetchRelateView() {

        this.relateViewSet = ViewSet.init({
          userId: this.$store.getters.userId,
          formId: this.viewSet.dataFormId,
          viewId: this.viewSet.detailViewId,
          companyId: this.$store.getters.currentCompanyId,
          appId: this.viewSet.dataAppId
        })
        if (this.viewSet.detailViewId === FORM_VIEW_TYPE_DATA_HANDLE) {
          // 选的是管理数据

        } else {
          // 数据视图
          this.$store.dispatch('actionFetchFormViewDetail', {
            formId: this.formId,
            viewId: this.viewId
          }).then(resultObject => {
            this.relateViewSet.setConf(resultObject)
          }).catch(console.error)
            .finally(() => {
              this.loading = false
            })
        }
      },

      getLocation() {

        this.pointList = []
        this.showDataList = []

        let map = null
        if (this.$refs.amap) {
          map = this.$refs.amap.$$getInstance()
        }
        console.log('getLocation', this.$refs.amap, map)
        if (!map) {
          return
        }
        map.clearMap()
        this.map = map
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：无穷大
          maximumAge: 0,           //定位结果缓存0毫秒，默认：0
          convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true,        //显示定位按钮，默认：true
          buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: false,        //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: false,        //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy:true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        map.addControl(geolocation);
        console.log(geolocation)
        geolocation.getCurrentPosition((status, result) => {
          console.log('result', status, result)
          if(status === 'complete') {//定位成功

            this.locationInfo.latitude = result.position.lat
            this.locationInfo.longitude = result.position.lng
            const address = result.addressComponent
            this.locationAddr = address.province + address.city + address.district + address.township + address.street + address.streetNumber;
            this.fetchDataViewData()

            const icon = new AMap.Icon({
              size: new AMap.Size(24, 40),    // 图标尺寸
              image: 'https://api.pro.surongyun.cn/fs/file/download/516371809210204161',
              imageSize: new AMap.Size(24, 40)   // 根据所设置的大小拉伸或压缩图片
            });

            this.locationMarker = new AMap.Marker({
              position: new AMap.LngLat(this.locationInfo.longitude, this.locationInfo.latitude),
              icon,
              offset: new AMap.Pixel(-26, -13),
              autoRotation: true,
              title: ''
            });
            map.add(this.locationMarker);

            map.setCenter([this.locationInfo.longitude, this.locationInfo.latitude])

            map.setFitView();//根据地图上添加的覆盖物分布情况，自动缩放地图到合适的视野级别
            map.setZoom(13)
          }
          if(status === 'error'){//定位失败
            if(result.info === 'NOT_SUPPORTED'){
              alert("当前浏览器不支持定位功能");
              return false;
            }
            if(result.info === 'FAILED'){
              var msg = result.message;
              if(msg.indexOf('Get ipLocation failed') !== -1){
                // alert("IP精确定位失败");
                return false;
              }
              if(msg.indexOf('sdk定位失败') !== -1){
                alert("请检查sdk的key是否设置好，以及webview的定位权限及应用和系统的定位权限是否开启");
                return false;
              }
              if(msg.indexOf('Browser not Support html5 geolocation') !== -1){
                alert("浏览器不支持原生定位接口");
                return false;
              }
              if(msg.indexOf('Geolocation permission denied') !== -1){
                alert("用户禁用了定位权限");
                return false;
              }
              if(msg.indexOf('Get geolocation time out') !== -1){
                alert("浏览器定位超时");
                return false;
              }
              if(msg.indexOf('Get geolocation failed') !== -1){
                alert("定位失败");
                return false;
              }
            }
          }
        });

        //地图加载失败
        map.on("error", function(){
          alert("地图加载失败，请重新进入页面或刷新当前页面重试");
        });

        const geocoder = new AMap.Geocoder({
          radius: 1000 //范围，默认：500
        });
        map.on('click', e => {
          console.log('click-----', e)
          // document.getElementById("lnglat").value = e.lnglat.getLng() + ',' + e.lnglat.getLat()
          this.locationMarker.setPosition(new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat()))

          this.locationInfo.latitude = e.lnglat.getLat()
          this.locationInfo.longitude = e.lnglat.getLng()

          map.setCenter([e.lnglat.getLng(), e.lnglat.getLat()])
          map.setZoom(13)

          this.fetchData()
          geocoder.getAddress(new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat()), (status, result) => {
            if (status === 'complete' && result.regeocode) {
              this.locationAddr = result.regeocode.formattedAddress;
            }else{
              log.error('根据经纬度查询地址失败')
            }
          });
        });

// 创建一个 Marker 实例： 34.33560887627616, lon: 108.94820553351279   108.94354, 34.33716
//         var marker = new AMap.Marker({
//           position: new AMap.LngLat(108.94820553351279, 34.33560887627616),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
//           title: '北京'
//         });

//将创建的点标记添加到已有的地图实例：
//         map.add(marker);
      },


      /**********************  数据视图操作 *************************/
      fetchDataViewData() {

        this.formSet = FormSet.init({
          userId: this.$store.getters.userId,
          companyId: this.$store.getters.currentCompanyId,
          formId: this.formId,
          appId: this.$store.getters.currentAppId
        })
        this.viewSet = ViewSet.init({
          userId: this.$store.getters.userId,
          formId: this.formId,
          viewId: this.viewId,
          companyId: this.$store.getters.currentCompanyId,
          appId: this.$store.getters.currentAppId
        })

        Promise.all([
          // 还原formSet结构
          this.$store.dispatch('actionMergeStructure', {
            formId: this.formId,
            formType: FORM_TYPE__FILL,
            viewType: 1,
            viewId: this.viewId,
          }).then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.formSet.setStructure(resultObject.structureInfo)
              this.formSet.setPermission(resultObject.permissionInfo.permissionList)
              this.formSet.setConf(resultObject.detailInfo)
              this.formSet.setWidth(resultObject.widthInfo)
              this.formSet.isInit = true
            }
          }),
          // 还原viewSet结构
          this.$store.dispatch('actionFetchFormViewDetail', {
            formId: this.formId,
            viewId: this.viewId
          }).then(resultObject => {
            this.viewSet.setConf(resultObject)
          }),
        ]).then(() => {
          this.fetchData()
          this.fetchRelateView()
        }).catch(console.error)
          .finally(() => {
            this.loading = false
          })
      },

      async fetchData() {
        this.map.remove(this.markerArray)
        this.markerArray.splice(0, this.markerArray.length)
        const res = await this.$store.dispatch('actionFormViewBubbleMapData', {
          appId: this.viewSet.appId,
          formId: this.formId,
          viewId: this.viewId,
          latitude: this.locationInfo.latitude,
          longitude: this.locationInfo.longitude,
          distance: this.radius,
          sortList: null,
          filter: this.filter,
          currentPage: 1,
          pageSize: 1000,
        }).catch(console.error)

        this.pointList = res.dataList
        this.handleDataList(res.headerList, res.dataList)

        console.log(this.pointList)
        this.pointList.forEach(point => {

          if (point.latitude && point.longitude) {

            let icon = ''
            if (this.viewSet.openCustomIcon === 'YES') {
              let match = false
              let iconUrl = ''
              for (let i = 0; i < this.viewSet.customIconConfigList.length; i++) {
                const config = this.viewSet.customIconConfigList[i]

                match = getFilterResults(config.filterInfo, point)
                console.log('getFilterResults', config, match, point)
                if (match) {
                  iconUrl = config.icon
                  break
                }
              }

              if (iconUrl) {
                icon = new AMap.Icon({
                  size: new AMap.Size(30, 30),    // 图标尺寸
                  image: iconUrl,
                  imageSize: new AMap.Size(30, 30)   // 根据所设置的大小拉伸或压缩图片
                });
              }
            }

            // 创建一个 Marker 实例： 34.33560887627616, lon: 108.94820553351279   108.94354, 34.33716
            const marker = new AMap.Marker({
              position: new AMap.LngLat(point.longitude, point.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: point.bubbleContent,
              icon
            });

            let content = point.bubbleContent
            if (point.bubbleContent.length > 30) {
              content = point.bubbleContent.slice(0, 30) + '...'
            }

            marker.setLabel({
              offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
              content: '<div class="info">'+ `${content}` + '</div>', //设置文本标注内容
              direction: 'top' //设置文本标注方位
            });
            // 将创建的点标记添加到已有的地图实例：
            this.map.add(marker);

            marker.instanceId = point.instanceId
            marker.on('click', e => {
              console.log('click', e, this.viewSet)
              if (this.viewSet.detailShowType === 'NOT') {
                return
              }

              if (this.viewSet.detailShowType === 'DETAIL') {
                let index = 0
                for (let i = 0; i < this.pointList.length; i++) {
                  if (this.pointList[i].instanceId === e.target.instanceId) {
                    index = i
                    break
                  }
                }
                this.$emit('onClickData', {
                  instanceId: e.target.instanceId,
                  viewId: this.viewSet.detailViewId,
                  dataList: this.pointList,
                  index
                })

              } else if (this.viewSet.detailShowType === 'CARD') {

                const values = this.pointList.filter(item => item.instanceId === e.target.instanceId)[0]

                if (values) {
                  const content = []

                  this.viewSet.detailCardConfig.forEach(fieldId => {
                    let value = ''
                    const item = this.formSet.fields[fieldId]
                    if (item && values[fieldId]) {
                      if (item.type === FORM_ITEM__IMAGE) {
                        values[fieldId].slice(0, 3).map(img => img.imgUrl).forEach(url => {
                          value += "<img style='width: 20px; height: 20px' src=" + url + ">"
                        })
                      } else if (item.type === FORM_ITEM__DATE) {
                        value = formatDate(values[fieldId])('yyyy/MM/dd HH:mm:ss')
                      } else {
                        value = item.valueToString(values[fieldId])
                      }
                      content.push("<div class='input-item'>" +
                        "<div class='title' style='color: #333333'" +  ">" +  `${item.fieldTitle}`+ "</div>" +
                        "：" +
                        "<div class='value' style='color: #3b4046'" +  ">" +`${value}` + "</div>" +
                        "</div>")
                    }
                  })

                  const infoWindow = new AMap.InfoWindow({
                    // isCustom: true,  //使用自定义窗体
                    content: this.createInfoWindow(values.bubbleContent, content.join("")),  //使用默认信息窗体框样式，显示信息内容
                    offset: new AMap.Pixel(0, -30),
                    closeWhenClickMap: true
                  });

                  infoWindow.open(this.map, marker.getPosition());
                }
              }

            });

            this.markerArray.push(marker)
          }
        })

      },
      createInfoWindow(title, content) {
        var info = document.createElement("div");
        info.className = "custom-info input-card content-window-card";

        //可以通过下面的方式修改自定义窗体的宽高
        info.style.width = "260px";
        // 定义顶部标题
        var top = document.createElement("div");
        var titleD = document.createElement("div");
        top.className = "info-top";
        titleD.innerHTML = title;

        top.appendChild(titleD);
        info.appendChild(top);

        // 定义中部内容
        var middle = document.createElement("div");
        middle.className = "info-middle";
        middle.innerHTML = content;
        info.appendChild(middle);

        return info;
      },

      // 处理展示数据
      handleDataList(headerList, dataList) {

        let showDataList = []
        dataList.forEach(item => {
          let showData = {
            key: uuid(),
            title: {},
            charge: {},
            time: {},
            image: {},
            content: [],
            applyTime: item['applyTime'],
            instanceId: item['instanceId'],
            stepId: item['stepId'],
            updateTime: item['updateTime'],
            userId: item['userId']
          }
          // 卡片title
          if (this.viewSet.cardConfigInfo.showTitle === 1) {
            showData.title = {
              showData: item[this.viewSet.cardConfigInfo.titleFieldId],
              fieldId: this.viewSet.cardConfigInfo.titleFieldId,
              type: 'title'
            }
          }
          // 卡片颜色
          if (this.viewSet.cardConfigInfo.showColor === 1) {
            // 获取当前选择的选项的id
            const optId = item[this.viewSet.cardConfigInfo.colorField]
            const field = this.formSet.fields[this.viewSet.cardConfigInfo.colorFieldId]
            let opt = null
            if (field) {
              opt = field.options.filter(opt => opt.id === optId)[0]
            }
            showData.color = {
              showData: opt ? opt.color : '',
              fieldId: this.viewSet.cardConfigInfo.colorField,
              type: 'color'
            }
          }
          // 截止时间
          if (this.viewSet.cardConfigInfo.showTime === 1) {
            const field = this.formSet.fields[this.viewSet.cardConfigInfo.timeFieldId]
            let formatStr = 'yyyy-MM-dd HH:mm'
            if (field) {
              formatStr = field.formatStr
            }

            showData.time = {
              showData: item[this.viewSet.cardConfigInfo.timeFieldId],
              fieldId: this.viewSet.cardConfigInfo.timeFieldId,
              formatStr, // 0 精确到天, 1精确到秒
              type: 'deadline'
            }
          }
          // 图片
          if (this.viewSet.cardConfigInfo.showImage) {
            if (this.viewSet.cardConfigInfo.imageFieldId.includes('IMAGE_')) {
              const imgArr = item[this.viewSet.cardConfigInfo.imageFieldId]
              showData.image = {
                showData: imgArr && imgArr.length > 0 ? imgArr[0].imgUrl : '',
                fieldId: this.viewSet.cardConfigInfo.imageFieldId,
                type: 'title'
              }
            } else {
              showData.image = {
                showData: item[this.viewSet.cardConfigInfo.imageFieldId],
                fieldId: this.viewSet.cardConfigInfo.imageFieldId,
                type: 'title'
              }
            }

          }
          // 卡片内容
          this.viewSet.cardConfigInfo.showFieldList.forEach(fieldId => {
            let field = this.formSet.fields[fieldId]
            if (field) {
              showData.content.push({
                showData: item[fieldId],
                type: field.type,
                ...field
              })
            }
          })
          showDataList.push(showData)
        })
        this.showDataList = showDataList
        console.log('showDataList', this.showDataList)
      },

      actionSelectFilterComplete(filter) {
        this.filter = filter
        this.fetchData()
      },

      foldFilter() {

      },

      openFilterPanel() {
        if (this.$refs.filterPanel) {
          this.$refs.filterPanel.open()
        }
      },

      radioChange() {
        // if (this.radio === 'filter') {
        //   this.openFilterPanel()
        // }
      },
      // 范围变化
      radiusChange() {
        console.log('radiusChange')
        this.fetchData()
      },

      actionFormatDate(d, formatter) {
        return formatDate(d)(formatter)
      },
      //  根据fieldId获取控件
      fetchFieldWithFieldId(fieldId) {
        return this.fieldList.filter(field => field.dataId === fieldId)[0] || {}
      },


      // 数据视图点击自定义按钮，执行事件后关闭弹窗，刷新数据
      updateData() {
        setTimeout(() => {
          this.refreshData()
        }, 800)
      },

      // 刷新数据视图
      refreshData() {

      },
      // 删除卡片
      deleteView() {
        // 删除成功后，关闭详情弹窗
        if (this.$refs.formViewDataDetail) this.$refs.formViewDataDetail.close()
        this.refreshData()
      },
      // 修改卡片数据
      saveFormData() {
        this.refreshData()
      },

      onClickCard(item) {
        if (this.viewSet.clickDetail === 'NO') {
          return
        }

        let index = 0
        for (let i = 0; i < this.pointList.length; i++) {
          if (this.pointList[i].instanceId === item.instanceId) {
            index = i
            break
          }
        }
        this.$emit('onClickData', {
          instanceId: item.instanceId,
          viewId: this.viewSet.detailViewId,
          dataList: this.pointList,
          index
        })
      },

      onClickTitle() {
        this.popupHeight = '80%'
        this.overlay = true
      },
      onClickOverlay () {
        this.popupHeight = '40px'
        this.overlay = false
      },
      onClickFilter() {
        if (this.$refs.formDataFilter) {
          this.$refs.formDataFilter.open(this.filter)
        }
      },
      onSelectRadius(opt) {
        this.radius = opt.value
        this.fetchData()
      }
    },
    watch: {}
  };
</script>

<style lang="less">

  .bubble-map-view-page {
    width: 100%;
    height: 100%;
    position: relative;

    .map-header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      min-height: 70px;
      height: auto;
      background-color: #fff;
      padding: 10px;
      z-index: 2;
      font-size: 14px;
      box-shadow: 0 2px 4px 0 rgba(43, 52, 65, 0.1);

      .location-address-container {
        display: flex;
        flex-direction: column;

        .location-address-wrapper {

          .location-address {
            color: #3FB27E;
          }
        }

        .tips {
          font-size: 12px;
          color: #2d8cf0;
          margin-top: 5px;
        }
      }

      .select-container {
        display: flex;
        margin-top: 10px;

        .select {
          margin: 0 10px;
          color: #2d8cf0;

        }
      }
    }

    .map__container-wrapper {
      position: relative;
      width: 100%;
      height: 100%;

      .amap-marker-label {
        border: none;
      }
    }

    .amap-info-close {
      top: 15px;
    }

    .amap-info-content {
      backdrop-filter: blur(1px);
      background: rgba(255, 255, 255, 0.9);
    }
    .amap-info-sharp {

      &:after {
        /*backdrop-filter: blur(1px);*/
        /*background: rgba(255, 255, 255, 0.9);*/
      }

    }

    .content-window-card {
      position: relative;
      box-shadow: none;
      bottom: 0;
      left: 0;
      width: auto;
      padding: 0;

      .info-top {
        position: relative;
        border-bottom: 1px solid #CCC;
        border-radius: 5px 5px 0 0;
        margin-right: 20px;
      }

      .info-top div {
        display: inline-block;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        line-height: 21px;
      }

      .info-middle {
        font-size: 12px;
        padding: 10px 6px;
        line-height: 20px;

        .input-item {
          width: 100%;
          display: flex;

          .title {
            width: 30%;
            font-weight: 500;
            text-align: right;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }

          .value {
            width: 70%;
            display: flex;

            >img {
              margin-right: 10px;
            }
          }
        }
      }

      span {
        margin-left: 5px;
        font-size: 11px;
      }

      .info-middle img {
        float: left;
        margin-right: 6px;
      }
    }

    .content-window-card p {
      height: 2rem;
    }

    .trigger-aside {
      position: absolute;
      /*left: 0;*/
      right: 385px;
      top: 50%;
      -webkit-transform: translate3D(0, -50%, 0);
      transform: translate3D(0, -50%, 0);
      width: 16px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #cacad3;
      background: #8cc5ff;
      box-shadow: 4px 0 4px 0 rgba(0, 0, 0, .1);
      border-radius: 0 8px 8px 0;
      cursor: pointer;
      -webkit-transition: -webkit-transform .3s ease-in-out;
      transition: -webkit-transform ease-in-out .3s;
      transition: transform ease-in-out .3s;
      transition: transform ease-in-out .3s, -webkit-transform ease-in-out .3s;
      z-index: 3;

      i {
        color: #ffffff;
      }
    }

    .handle-panel {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 400px;
      background-color: #fff;
      padding: 10px;
      z-index: 2;
      border-left: 1px solid #e6e6e6;

      .path-handle-container {

        .path-title {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 10px;
        }

        .handle-container {
          display: flex;
          margin-bottom: 10px;
        }

        .total {
          font-size: 14px;

          > span {
            color: #2d8cf0;
          }
        }
      }

      .list-card-container {
        height: calc(100% - 62px);
        width: 100%;
        overflow: auto;
        margin-top: 20px;

        .list-card {
          position: relative;
          width: 360px;
          margin: 0 auto;
          background-color: #fff;
          display: flex;
          overflow: hidden;
          color: #303133;
          border-bottom: 1px solid #e6e6e6;
          padding-bottom: 10px;

          .color {
            width: 5px;
            background-color: #4A66FA;
          }

          .list-card-wrapper {
            cursor: pointer;
            display: flex;
            flex: 1 1;
            width: calc(100% - 5px);

            .card-info {
              padding: 10px 10px 0 10px;
              width: calc(100% - 100px);

              .title {
                display: flex;
                align-items: center;

                .color {
                  width: 5px;
                  height: 16px;
                  background-color: #4A66FA;
                  margin-right: 5px;
                }

                h3 {
                  height: 18px;
                  font-size: 16px;
                  font-weight: 700;
                  color: #262626;
                  line-height: 18px;
                  margin: 10px 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              p {
                font-size: 13px;
                color: #4A66FA;
                margin: 0;
              }

              .card-info-row {
                display: flex;
                flex-direction: column;

                .row-item {
                  flex: 1 1;
                  display: flex;
                  align-items: center;

                  h5 {
                    font-size: 11px;
                    color: #979797;
                    line-height: 16px;
                    margin: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }

                  .item-content {
                    height: 26px;
                    display: flex;
                    align-items: center;
                    color: #262626;
                    font-size: 14px;
                  }
                }
              }
            }

            .img-container {
              border-radius: 1px;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                width: 90px;
                height: 90px;
                object-fit: cover;
              }
            }
          }

        }

        .empty-data-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          i {
            font-size: 30px;
            margin-bottom: 20px;
          }
        }
      }

      .filter-item-container {
        height: calc(100% - 60px);
        width: 100%;

        > .filter-panel-container {
          height: 100%;
        }
      }
    }
  }

  .empty-page {
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    background-color: #fff;
  }

  .list-card-popup {

    .popup-title {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
    }

    .list-card-container {
      height: calc(100% - 40px);
      width: 100%;
      overflow: auto;

      .select-group {
        color: #4A66FA;
        font-size: 13px;
        margin-left: 20px;
      }

      .list-card {
        position: relative;
        width: 360px;
        margin: 0 auto;
        background-color: #fff;
        display: flex;
        overflow: hidden;
        color: #303133;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 10px;

        .color {
          width: 5px;
          background-color: #4A66FA;
        }

        .list-card-wrapper {
          cursor: pointer;
          display: flex;
          flex: 1 1;
          width: calc(100% - 5px);

          .card-info {
            padding: 10px 10px 0 10px;
            width: calc(100% - 100px);

            .title {
              display: flex;
              align-items: center;

              .color {
                width: 5px;
                height: 16px;
                background-color: #4A66FA;
                margin-right: 5px;
              }

              h3 {
                height: 18px;
                font-size: 16px;
                font-weight: 700;
                color: #262626;
                line-height: 18px;
                margin: 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            p {
              font-size: 13px;
              color: #959699;
              margin: 0;
            }

            .card-info-row {
              width: 100%;
              display: flex;
              flex-direction: column;

              .row-item {
                width: 100%;
                flex: 1 1;
                display: flex;
                align-items: center;
                margin-bottom: 6px;

                h5 {
                  font-size: 11px;
                  color: #979797;
                  line-height: 16px;
                  max-width: 100px;
                  min-width: 40px;
                  margin: 0;
                  display: inline-block;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }

                .item-content {
                  flex: 1;
                  height: auto !important;
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                  color: #262626;

                  > div {
                    width: 100%;
                    padding-left: 0;
                    padding-right: 0;
                    margin-right: 8px;
                    line-height: 18px;
                    height: auto;
                    color: #5e6d82;
                  }
                  .field-show-data-container > div {
                    line-height: 18px;
                  }

                  .field-show-data-content {
                    display: block;
                    line-height: 18px;
                    white-space: normal;
                  }
                }
              }
            }
          }

          .img-container {
            border-radius: 1px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 90px;
              height: 90px;
              object-fit: cover;
            }
          }
        }

      }
    }
  }
</style>